import axios from 'axios';
import storage from 'redux-persist/lib/storage'
import {
  TEXT_FIELD_CHANGED,
  SET_USER_TYPE,
  SET_LOADING,

  LOGIN,
  LOGIN_FAIL,
  LOGIN_SUCCESS,

  PARTNER_LOGIN_FAIL,
  PARTNER_LOGIN_SUCCESS,

  RESET_PASSWORD,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  SET_PASSWORD_HASH,
  NEW_PASSWORD_SET,
  NEW_PASSWORD_SET_FAIL,
  NEW_PASSWORD_SET_SUCCESS,

  AUTH_USER_TOKEN_EXPIRY,
  GENERAL_REQUEST_LOADING,
  GENERAL_REQUEST_LOADED,

  SNACKBAR_SET,
  LOGOUT,
  ERROR_CLEAR,
  REFRESH_USER
} from './types';
import history from '../utility/common/History.js';
import { noRefUrls } from '../utility/common/Routes';
import { getMeta } from '../services/MetaService';

const { REACT_APP_API_URL } = process.env;

// ********************************************************************************
// General Use
// ********************************************************************************
export const refreshUser = (url, id, state, browserInfo) => {
  
  return (dispatch) => {
    localStorage.clear();
    history.push('/');
    dispatch({
      type: REFRESH_USER,
    });
    axios.post(`${REACT_APP_API_URL}/refresh/log`, {
      data: 
      { 
        message: 'User '+id,
        state: state,
        browserInfo: browserInfo,
        url: url,
      }
    })
    .then((response) => {
      if (response.data.code === 0) {
        console.log(state);
      } else {
        console.log(state);
      }
    })
    .catch((error) => {
      console.log(state);
    })
  }
}

export const updateField = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: TEXT_FIELD_CHANGED,
      fieldName: fieldName,
      fieldValue: fieldValue
    })
  };
};

export const setUserType = (type) => {
  return {
    type: SET_USER_TYPE,
    payload: type
  }
};

export const setLoading = (status) => {
  return {
    type: SET_LOADING,
    payload: status
  }
};

export const clearErrors = () => {
  return {
    type: ERROR_CLEAR
  }
};

export const logout = (type) => {
  return (dispatch) => {
    dispatch({ type: LOGOUT });
    storage.removeItem('persist:root');
    storage.removeItem('token');
    storage.removeItem('expiry');
    switch(type) {
      case 'AGENT':
        return history.push('/partner/login');
      case 'MANAGER':
        return history.push('/partner/login');
      default:
        return history.push('/login');
    }
  };
};
export const redirectTo = (url, message='') => {
  return (dispatch) => {
    if(message !== ''){
      dispatch({
        type: SNACKBAR_SET,
        message: message,
        severity: 'notificationBarFailed',
        horizontal: 'center',
        vertical: 'bottom',
      });
    }
    return  history.push(url);
  }

}

export const checkUser = ({ id, pw, type, refUrl }) => {
  return (dispatch) => {

    dispatch({ type: LOGOUT });

    dispatch({ type: LOGIN });

    validateLogin(dispatch, id, pw, type, refUrl);

  };
};

// ********************************************************************************
// Login
// ********************************************************************************

const validateLogin = (dispatch, id, pw, type, refUrl) => {

  let errors = {};

  if(isNaN(id) || id === 0 || id === '') errors[type] = `Please fill out your ${type} ID`;

  if(pw === 0 || pw === '') errors.PASSWORD = 'Please fill out your password';

  if(noRefUrls.includes(refUrl)){
    refUrl = (type == 'EMPLOYEE')? '/': '/partner';
  }

  if(Object.keys(errors).length > 0){
    errors.GENERAL = 'Please correct the information above'
    loginUserFail(
      dispatch,
      true,
      errors
    );
  } else {
    switch(type) {
      case 'EMPLOYEE':
        return authUser(dispatch, id, pw, refUrl);
      case 'AGENT':
        return authAgent(dispatch, id, pw, refUrl);
      case 'MANAGER':
        return authAgent(dispatch, id, pw, refUrl);
      default:
        return;
    }
  }

};

const authUser = (dispatch, id, pw, refUrl) => {
  const errors = {};

  axios.post(`${REACT_APP_API_URL}/login/`, {
    id: id,
    pw: pw,
    meta: getMeta()
  })
  // axios({
  //   method: 'post',
  //   url: `/login/`,
  //   baseURL: `${REACT_APP_API_URL}`,
  //   headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
  //   withCredentials: false,
  //   data: JSON.stringify({
  //     id: id,
  //     pw: pw
  //   }),
  //   responseType: 'json'
  // })
  .then((response) => {
    if (response.data.code === 0) {
      loginUserSuccess(
        dispatch,
        response.data.data
      );

      storage.setItem('token',response.data.data.token);
      storage.setItem('expiry',response.data.data.expiry);
      history.push(refUrl);
    } else {
      loginUserFail(
        dispatch,
        true,
        response.data.data.error
      );
    }
  })
  .catch((error) => {
    errors.GENERAL = 'There was a problem connecting to the server, please contact Olympia Benefits.';
    loginUserFail(
      dispatch,
      true,
      errors
    );
  });
};

const loginUserFail = (dispatch, error, errors) => {
  dispatch({
    type: LOGIN_FAIL,
    error,
    errors
  });
  dispatch({
    type: SNACKBAR_SET,
    message: errors.GENERAL,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
};

const loginUserSuccess = (
  dispatch,
  data,
) => {
  dispatch({
    type: LOGIN_SUCCESS,
    data,
  });
};


// ********************************************************************************
// Reset Password / Update Password
// ********************************************************************************

export const checkResetPass = ({ id, email, type }) => {
    return (dispatch) => {

      dispatch({ type: RESET_PASSWORD });

      validateResetPassword(dispatch, id, email, type);

    };
};

const validateResetPassword = (dispatch, id, email, type) => {

  let errors = {};
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;

  if(isNaN(id) || id === 0 || id === '') errors[type] = `Please fill out your ${type} ID`;

  if(email === '' || reg.test(email) === false) errors.EMAIL = 'Please fill out a valid email address';

  if(Object.keys(errors).length > 0){
    errors.GENERAL = 'Please correct the information above'
    resetPassFail(
      dispatch,
      true,
      errors
    );
  } else {
    resetPass(dispatch, id, email, type);
  }

};

const resetPass = (dispatch, id, email, type) => {

  const errors = {};

  axios.post(`${REACT_APP_API_URL}/password/reset/`, {
    id: id,
    email: email,
    type: type
  })
  .then((response) => {
    if (response.data.code === 0) {
      resetPassSuccess(dispatch, type);
    } else {
      resetPassFail(
        dispatch,
        true,
        response.data.data.error
      );
    }
  })
  .catch((error) => {
    errors.GENERAL = 'There was a problem connecting to the server, please contact Olympia Benefits.';
    resetPassFail(
      dispatch,
      true,
      error
    );
  });

};

const resetPassFail = (dispatch, error, errors) => {
  dispatch({
    type: RESET_PASSWORD_FAIL,
    error,
    errors
  });
  dispatch({
    type: SNACKBAR_SET,
    message: errors.GENERAL,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
};

const resetPassSuccess = (dispatch, type) => {
    dispatch({
      type: RESET_PASSWORD_SUCCESS
    });
    switch(type) {
      case 'agent':
        return history.push('/partner/login/reset/success');
      default:
        return history.push('/login/reset/success');
    }
};

export const setPassHash = (hash) => {
  return (dispatch) => {
    dispatch({ type: SET_PASSWORD_HASH, hash });
  };
};

export const checkNewPass = ({ npw1, npw2, pwhash, type }) => {
  return (dispatch) => {

    dispatch({ type: NEW_PASSWORD_SET });

    validateNewPassword(dispatch, npw1, npw2, pwhash, type);

  };
};

const validateNewPassword = (dispatch, npw1, npw2, hash, type) => {

  let errors = {};

  if(npw1.length < 8) errors.NPW1 = 'Your password must be at least 8 characters';

  if(npw2.length < 8) errors.NPW2 = 'Your password must be at least 8 characters';

  if(npw1 === '') errors.NPW1 = 'Please fill out a new password';

  if(npw2 === '') errors.NPW2 = 'Please fill out a new password';

  if(npw2 !== npw1) {

    errors.NPW1 = 'Your passwords need to match';

    errors.NPW2 = 'Your passwords need to match';

  }

  if(Object.keys(errors).length > 0){
    errors.GENERAL = 'Please correct the information above'
    newPassFail(
      dispatch,
      true,
      errors
    );
  } else {
    setNewPass(dispatch, npw1, hash, type);
  }

};

const setNewPass = (dispatch, pw1, hash, type) => {

  const errors = {};

  axios.post(`${REACT_APP_API_URL}/password/update/`, {
    pw1: pw1,
    hash: hash,
    type: type
  })
  .then((response) => {
    if (response.data.code === 0) {
      newPassSuccess(dispatch, response.data.data.message, type);
    } else {
      newPassFail(
        dispatch,
        true,
        response.data.data.error
      );
    }
  })
  .catch((error) => {
    errors.GENERAL = 'There was a problem connecting to the server, please contact Olympia Benefits.';
    newPassFail(
      dispatch,
      true,
      error
    );
  });

};

const newPassFail = (dispatch, error, errors) => {
  dispatch({
    type: NEW_PASSWORD_SET_FAIL,
    error,
    errors
  });
  dispatch({
    type: SNACKBAR_SET,
    message: errors.GENERAL,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
};

const newPassSuccess = (dispatch, message, type) => {
    dispatch({
      type: NEW_PASSWORD_SET_SUCCESS,
      message
    });
    switch(type) {
      case 'AGENT':
        return history.push('/partner/login/update/success');
      default:
        return history.push('/login/update/success');
    }
};


// ********************************************************************************
// Agent
// ********************************************************************************

const authAgent = (dispatch, id, pw, refUrl) => {

  const errors = {};

  axios.post(`${REACT_APP_API_URL}/partner/login/`, {
    id: id,
    pw: pw,
    meta: getMeta()
  })
  .then((response) => {
    if (response.data.code === 0) {
      loginAgentSuccess(
        dispatch,
        response.data.data
      );
      storage.setItem('token',response.data.data.token);
      storage.setItem('expiry',response.data.data.expiry);
      history.push(refUrl);
    } else {
      loginAgentFail(
        dispatch,
        true,
        response.data.data.error
      );

    }
  })
  .catch((error) => {
    errors.GENERAL = 'There was a problem connecting to the server, please contact Olympia Benefits.';
    loginAgentFail(
      dispatch,
      true,
      error
    );
  });
};

const loginAgentFail = (dispatch, error, errors) => {
  dispatch({
    type: PARTNER_LOGIN_FAIL,
    error,
    errors
  });
  dispatch({
    type: SNACKBAR_SET,
    message: errors.GENERAL,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
};

const loginAgentSuccess = (
  dispatch,
  data
) => {
  dispatch({
    type: PARTNER_LOGIN_SUCCESS,
    data
  });
};

/*--------------------------------- Expiry Api Extend -----------------------------------------*/
export const authExtendExpiry = (token) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    axios.post(`${REACT_APP_API_URL}/extend-token`, {
      token: token
    })
    .then((response) => {
      if (response.data.code === 0) {
        updateUserTokenExpiration(dispatch, response.data.data.TOKEN_EXPIRY);
        dispatch({ type: GENERAL_REQUEST_LOADED });
      }
      else {
        //error display
        dispatch({ type: GENERAL_REQUEST_LOADED });
      }
    })
    .catch((error) => {
      //error display
      dispatch({ type: GENERAL_REQUEST_LOADED });
    });
  }
};


/*------------------------- Expiry Storage + Reducer Extend ------------------------------------*/
export const updateUserTokenExpiration = (dispatch, token_expiry) => {
  dispatch({
    type: AUTH_USER_TOKEN_EXPIRY,
    expiry: token_expiry
  });
  storage.setItem('expiry',token_expiry);
};
